import React from "react";
import ChecklistItem from "./ChecklistItem";
import ChecklistAddRow from "./ChecklistAddRow";
import { useChecklist } from "./useChecklist";
import "./Checklist.css";

/**
 * @component
 * @param {object} props
 * @param {[{text:string, id:number}]} props.initialItems
 * @param {function} props.onAdd
 * @param {function} props.onUpdate
 * @param {function} props.onRemove
 * @param {function} props.onToggle
 * @param {function} props.onChange
 * @param {boolean} props.editable
 * @param {string} props.classNames
 * @returns 
 */
export default function Checklist({
  initialItems,
  onAdd,
  onUpdate,
  onRemove,
  onToggle,
  onChange,
  onSetComment,
  editable = true,
  orderable = true,
  checkable = true,
  hasDoneComment,
  classNames = "",
  title=""
}) {
  const {
    items,
    insertedItems,
    updatedItems,
    removedItems,

    addItem,
    updateItem,
    removeItem,
    toggleItem,
    setComment,
    moveItemUp,
    moveItemDown,
  } = useChecklist(initialItems??[], {
    onAdd,
    onUpdate,
    onRemove,
    onToggle,
    onChange,
    onSetComment
  });

  return (
    <div className={`custom-checklist-container ${classNames}`}>
        <h6 className="custom-checklist-title">{title}</h6>
      {items.map((item, index) => (
        <ChecklistItem
          key={item.id}
          item={item}
          checkable={checkable}
          editable={editable}

          hasDoneComment={hasDoneComment}
          index={index}
          onToggle={() => toggleItem(item.id)}
          onRemove={() => removeItem(item.id)}
          onUpdate={(val) => updateItem(item.id, val)}
          onMoveUp={() => moveItemUp(index)}
          onMoveDown={() => moveItemDown(index)}
          onSetComment={(comment)=>setComment(item.id, comment)}
        />
      ))}

      {editable && <ChecklistAddRow onAdd={addItem} />}
    </div>
  );
}